module.exports = __webpack_public_path__ + "static/media/03-bgimg-01@3x.af5e6901.webp";